// extracted by mini-css-extract-plugin
export default {"component":"b2Hzvl","reset":"c2Hzvl","legend":"d2Hzvl","search":"e2Hzvl","distanceDropdown":"f2Hzvl","provinceCheckbox":"g2Hzvl","imgFooter":"h2Hzvl","menu":"i2Hzvl"};